import { createI18n } from 'vue-i18n'
import bg from '@/plugins/i18n/locales/bg.json'
import cy from '@/plugins/i18n/locales/cy.json'
import de_CH from '@/plugins/i18n/locales/de_CH.json'
import de from '@/plugins/i18n/locales/de.json'
import en from '@/plugins/i18n/locales/en.json'
import es from '@/plugins/i18n/locales/es.json'
import et from '@/plugins/i18n/locales/et.json'
import fr from '@/plugins/i18n/locales/fr.json'
import ga from '@/plugins/i18n/locales/ga.json'
import gu from '@/plugins/i18n/locales/gu.json'
import hi from '@/plugins/i18n/locales/hi.json'
import hu from '@/plugins/i18n/locales/hu.json'
import lt from '@/plugins/i18n/locales/lt.json'
import lv from '@/plugins/i18n/locales/lv.json'
import nl from '@/plugins/i18n/locales/nl.json'
import pl from '@/plugins/i18n/locales/pl.json'
import ro from '@/plugins/i18n/locales/ro.json'
import sk from '@/plugins/i18n/locales/sk.json'
import tr from '@/plugins/i18n/locales/tr.json'
import uk from '@/plugins/i18n/locales/uk.json'
import zh_CN from '@/plugins/i18n/locales/zh_CN.json'
import zh_TW from '@/plugins/i18n/locales/zh_TW.json'


/* const messages = Object.fromEntries(
  Object.entries(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    import.meta.glob<{ default: any }>('./locales/*.json', { eager: true }))
    .map(([key, value]) => [key.slice(10, -5), value.default]),
) */

export default createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  messages: {
    bg,
    cy,
    de_CH,
    de,
    en,
    es,
    et,
    fr,
    ga,
    gu,
    hi,
    hu,
    lt,
    lv,
    nl,
    pl,
    ro,
    sk,
    tr,
    uk,
    zh_CN,
    zh_TW,
  },
  warnHtmlMessage: false, // We handle the HTML sanitization through dompurify
})
